var g_RightsChanged = 0;

function UserRightInit(ClientID, ObjectID, HashCode, Msg, IsNeedHideTree) {
  var jRightsTable = $('.Rights');
  var updateTree = function (event, hideFilterView) {
    if (IsNeedHideTree) {
      if (hideFilterView) $('#Filter_User_View_' + ClientID).hide();
      var rootUl = $('#ul' + ClientID).empty();
      rootUl.treeview({
        url: "/UserList.asmx/GetUsers",
        collapsed: true,
        ajax: {
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          dataWS: "'ObjectID':" + ObjectID + ", 'ObjectType':" + HashCode + ",'Filtrator':'' ",
          async: true,
          cache: false,
          type: "post",
          onAfterSuccess: function (el, cont) {
            $(el).find('.hint').each(function () {
              InitAdditionalInfoTooltip($(this));
            });
            MarkAllGroupsAndUsers(jRightsTable);
           $('#spinnerDiv').hide();
            if ($('#0').children('ul').children().length == 0) {
              $('#ShowingTreeError').show();
            } else {
              $('#ShowingTreeError').hide();
            }

           $('#scroller').height($('#right_column').height());

           if ($.ipad || WA.ENV.isAndroid()) {
              InitTabletContextMenu($('.Rights_List_div:not(#g_0)', el));
            }
          }
        }
      });
    }
    jRightsTable.delegate('.Rights_List_div', 'mouseover', UserInTreeMouseOver);
    jRightsTable.delegate('.Rights_List_div', 'mouseout', UserInTreeMouseOut);
    jRightsTable.delegate('.Rights_Table tr', 'mouseover', UserRightsMouseOver);
    jRightsTable.delegate('.Rights_Table tr', 'mouseout', UserRightsMouseOut);
    if (!$.ipad && !WA.ENV.isAndroid()) {
      jRightsTable.undelegate('.Rights_List_div > span', 'contextmenu').delegate('.Rights_List_div:not(#g_0) > span', 'contextmenu', UserListShowContextMenu);
    } else {
      var contextmenuButton = '<svg class="user-tree__menu-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#hamburger-20"></use></svg>';
      $('.Rights_List_div:not(#g_0)', jRightsTable).find('p.icon').before(contextmenuButton).prev().unbind('click').bind('click', UserListShowContextMenu);
    }
    // Если текущий объект не передан, значит вызывается для массовой установки прав, там навигация не требуется.
    if (ObjectID !== '-1') {
      InitRightsUserTreeKeyNavigation();
    }

    // Шамов А.: keydown сделано специально, т.к. на keyup не блокируется Enter.
    var filterInput = $('#Filter_User_' + ClientID);
    filterInput.keydown(function (ev) {
      if (ev.keyCode == 9) {
        filterInput.blur();
        var firstItem = $('.Rights_List_div:visible:first', '.Rights_User_List');
        if (firstItem.length == 0) firstItem = $('.Rights_User_List').find('ul').find('.Rights_List_div:visible:first');
        UserInTreeMouseOver({ currentTarget: firstItem });
      } else {
        return FilterUserAjax(ev, 'ul' + ClientID, 'Filter_User_View_' + ClientID, ObjectID, HashCode, this, Msg);
      }
    });
  };

  // Изменились ли права, чтобы при переходе на другую вкладку руннуться на сохраненные данные.
  jRightsTable.on('rightsChange', function () {
    g_RightsChanged = 1;
  });

  jRightsTable.on('reload.UserTree', updateTree);
  updateTree(null, true);
}

function CheckIfFavoritesEmpty(favGroup) {
  if (favGroup.children('ul').children().length > 0) {
    $('#ShowingTreeError').hide();
  }
  else {
    if ($('.treeview:visible').length > 0) {
      favGroup.attr('class', '');
      $('#ShowingTreeError').show();
    }
  }
}


function fillTree(res) {
  var html = "";
  if (res.Error == null) {
    if (res.Result.length > 0) {
      var nodes = res.Result;
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id > 0) {
          html += buildTreeNodeHTML(nodes[i]);
        }
        else {
          //this.showGroupsListMessage(nodes[i].text);
        }
      }
    }
  }
  return html;
}

function buildTreeNodeHTML(node) {
  var html = node.text;
  return html;
}

function MarkAllGroupsAndUsers(RightsTable) {
  var selectedIDs = $('[name=__SELECTED_USERS]').val().split(';');
  for (var i = 0; i < selectedIDs.length; i++) {
    var id = selectedIDs[i].split('-')[0];
    if (id != "") MarkUser(RightsTable.find('#' + id), true);
  }
}

function InitTabletContextMenu(items) {
  if (items.find('.tabletcontextm').length > 0) {
    items.find('.tabletcontextm').unbind('click').bind('click', UserListShowContextMenu);
  } else {
    var contextmenuButton = '<svg class="user-tree__menu-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#hamburger-20"></use></svg>';
    items.find('p.icon').before(contextmenuButton).prev().unbind('click').bind('click', UserListShowContextMenu);
  }
}

function UserListShowContextMenu(e) {
  e.preventDefault(); e.stopPropagation();
  var currObj = $(this);
  if (!currObj.attr('id')) currObj = currObj.parents('.Rights_List_div:first');
  var menu = _GetContextMenu(currObj, $('#0'));
  menu.showAt({ 'left': e.pageX, 'top': e.pageY });
}

// получает объект контекстного меню для элемента дерева
function _GetContextMenu(item, favoritesGroup) {
  var menuItems = [];
  var addMenuItemText;
  var addClickHandler;
  var favoritesMenuItemText;
  var favoritesClickHandler;
  var favoritesIcon = "folderFavorites-16";
  var itemID = item.attr('id');
  var actionIcon;
  var liID = itemID;
  if (itemID[0] == 'g') { liID = itemID.substr(2); }
  if (favoritesGroup.children('ul').children('#' + liID).length > 0 || item.hasClass('favorite')) {
    favoritesMenuItemText = L("REMOVE_FROM_FAVORITES");
    favoritesClickHandler = function () {
      addOrRemoveFavorites(item, itemID, false, favoritesGroup);
    };
    favoritesIcon = "deleteFromFavourites-16";
  }
  else {
    favoritesMenuItemText = L("ADD_TO_FAVORITES");
    favoritesClickHandler = function () {
      addOrRemoveFavorites(item, itemID, true, favoritesGroup);
    };
  }
  if (IsSelected(itemID)) {
    // то элемент уже выбран
    addMenuItemText = L("USERGROUP_EXCLUDE");
    addClickHandler = function () {
      $('.Rights_Table').find('tr[id$=' + itemID + ']').find('p:first').trigger('click');
    };
    actionIcon = "unchooseRecord-16";
  }
  else {
    addMenuItemText = L("USERGROUP_INCLUDE");
    addClickHandler = function () { AddUserByDiv(item); MarkUser(item, true); };
    actionIcon = "chooseRecord-16";
  }

  menuItems.push({ text: addMenuItemText, onClick: addClickHandler, icon: actionIcon });
  menuItems.push({ text: favoritesMenuItemText, onClick: favoritesClickHandler, icon: favoritesIcon });

  var menu = new ContextMenu(menuItems, { width: "auto" });
  var proxy = { id: item.attr('id'), kind: 'ref', refcode: WA.CR.getReferenceCode(), elem: item, tr: item };
  menu.self = proxy
  return menu
}

// Добавление или удаление пользователей из избранного
// item - элемент, который надо добавить
// needToAdd - нужно ли добавить или удалить
function addOrRemoveFavorites(item, itemId, needToAdd, favoritesGroup) {
  var liID = itemId;
  var isGroup = false;
  if (itemId[0] == 'g') { liID = itemId.substr(2); isGroup = true; }
  CallService("/UserList.asmx/AddOrRemoveFavorites", { PrincipalID: liID, IsGroup: isGroup, NeedToAdd: needToAdd },
    function (res) {
      if (res.Success) {
        var favGroupUl = favoritesGroup.children('ul');
        if (favGroupUl.length == 0) {
          favGroupUl = $('<ul></ul>');
          favoritesGroup.append(favGroupUl);
        }
        if (needToAdd) {
          if (favGroupUl.children('#' + liID).length == 0) {
            var clone;
            if (item.parent('.Filter_User_View').length > 0) {
              ReloadFavoritesGroup(favoritesGroup, favGroupUl);
            }
            else {
              clone = item.parent().parent().clone();
              initTreeViewItemEvents(clone);
              clone.appendTo(favGroupUl);
              clone.removeClass('collapsable');
              clone.find('.collapsable').removeClass('collapsable');
              if (favGroupUl.children().length == 1) {
                if (favoritesGroup.children('.hitarea').length == 0) {
                  favoritesGroup.prepend('<div class="hitarea"></div>');
                }
                $('.treeview').treeview({ add: favoritesGroup });
              } else {
                $('.treeview').treeview({ add: clone });
              }
            }
            markUnmarkItemAsFavorite(itemId, needToAdd);
          }
        }
        else {
          favGroupUl.children('li#' + liID).remove();
          markUnmarkItemAsFavorite(itemId, needToAdd);
        }
        CheckIfFavoritesEmpty(favoritesGroup);
      }
    });
}

function ReloadFavoritesGroup(favoritesGroup, favGroupUl) {
  //var hitArea = favoritesGroup.children('.hitarea');
  //  if (hitArea.length > 0) {
  //    favoritesGroup.removeClass('open').addClass('hasChildren');
  //    favGroupUl.empty();
  //    hitArea.click().click();
  //    favoritesGroup.hasClass('expandable') ? favGroupUl.hide() : favGroupUl.show();
  //  } else {
  $('.Rights').data('needUpdTree', true);
  //}
}

function initTreeViewItemEvents(item) {
  var span = item.find('.Rights_List_div')
    .bind('mouseover', UserInTreeMouseOver)
    .bind('mouseout', UserInTreeMouseOut)
    .on('click', function () {
      var el = $(this);
      AddUserByDiv(el);
      MarkUser(el, true);
    })
    .children('span');
  if ($.ipad || WA.ENV.isAndroid()) {
    InitTabletContextMenu(item.find('.Rights_List_div'));
  } else {
    span.bind('contextmenu', UserListShowContextMenu);
  }
}

function AddFavoritesToRightsTable(el) {
  $(el).parent().siblings('ul').children().find('.Rights_List_div:first').click();
}

function IsSelected(ItemId) {
  var selectedIDs = $('[name=__SELECTED_USERS]').val().split(';');
  var isSelected = false;
  for (var i = 0; i < selectedIDs.length; i++) {
    var id = selectedIDs[i].split('-')[0];
    if (id == ItemId) isSelected = true;
  }
  return isSelected;
}

// Помечает или снимает отметку избранных пользователей или групп
// isFavorite - признак пометить как избранное или нет
function markUnmarkItemAsFavorite(id, isFavorite) {
  if (id) {
    var item = $('.treeview').children(':not(#0)').find('#' + id).add($('.Filter_User_View').find('#' + id));
    var icon = item.children('span').find('p.icon');
    var isGroup = id[0] == 'g';
    var iconClass = isGroup ? 'user-tree__icon_group' : 'user-tree__icon_user';
    var isSelected = IsSelected(id);

    if (isFavorite) {
      if (id[0] != 'g') { // если это пользователь
        if (!isSelected) { // у выбранных записей иконки не меняем
          icon.removeClass(iconClass).addClass('user-tree__icon_fav-user');
        }
      } // если это группа
      else {
        if (!isSelected) {
          icon.removeClass('user-tree__icon_group').addClass('user-tree__icon_fav-group');
        }
      }
      item.addClass('favorite');
    }
    else {
      if (id[0] != 'g') { // если это пользователь
        if (!isSelected) { // у выбранных записей иконки не меняем
          icon.removeClass('user-tree__icon_fav-user').addClass(iconClass);
        }
      } // если это группа
      else {
        if (!isSelected) {
          icon.removeClass('user-tree__icon_fav-group').addClass('user-tree__icon_group');
        }
      }
      item.find('.favorite').removeClass('favorite');
      item.removeClass('favorite');
    }
  }
}

function UserRightTreeInit(ClientID, ObjectID, GetHashCode) {
  $('#ul>' + ClientID).treeview({
    url: "/UserList.asmx/GetUsers",
    collapsed: true,
    ajax: {
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      dataWS: "'ObjectID':'" + ObjectID + "','ObjectType':'" + GetHashCode + "','Filtrator':''",
      async: true,
      cache: false,
      type: "post"
    }
  });

  // Событие при наведении на элемент дерева.
  $('.treeview div').live('mouseover', function () { $(this).addClass('over'); });
  $('.treeview div').live('mouseout', function () { $(this).removeClass('over'); });

  setTimeout(SetEvents, 1000);
  SetCurrentUsers();
}

// Функция при наведение мышки на пользователя или группу в дереве.
function UserInTreeMouseOver(event) {
  var el = event.currentTarget;
  $('div.over', '.Rights_User_List').removeClass('over').find('p.treeview_img_action').css('visibility', 'hidden');
  if ($(el).length) {
    if (!$(el).hasClass("marked")) {
      var arrow = $(el).find('p.treeview_img_action');
      arrow.css('visibility', 'visible');
      //$(el).find('span > div').attr('title', arrow.attr('title'));
    }
  }
  $(el).addClass('over');
}

// Функция при отведение мышки с пользователя или группы в дереве.
function UserInTreeMouseOut(event) {
  $('div.over', '.treeview').removeClass('over').find('p.treeview_img_action').css('visibility', 'hidden');
  var el = event.currentTarget;
  $(el).find('p.treeview_img_action').css('visibility', 'hidden');
  // $(el).find('span > div').attr('title', '');
  $(el).removeClass('over');
}

// Клик на кружочке.
function SetRightChoose(elem) {
  SetNewRight(elem);
}

function GetUserID(tr) {
  var UserID = tr.attr('id');
  var prefixIndex = UserID.indexOf('_');
  if (prefixIndex != -1) {
    UserID = UserID.substr(prefixIndex + 1);
  }
  return UserID;
}

var g_OldChangedUsers = {};

// Устанавливает права для выбранного пользователя.
function SetNewRight(el) {
  el = $(el);
  var rights = el.attr("class");
  var rightsID = el.attr("name");
  var tbl = $(el).parentsUntil("table");
  var UserID = GetUserID($(tbl[tbl.length - 2]));
  var currentRightVal;

  var isOldUser = IsOldUser(UserID); // супер логика для изменения прав, имея неполные права. для пользователей которые уже есть в списке можем только повышать права

  //Проверка полных прав
  // не можем менять права пользователей если у них полные,а у нас нет
  if (rightsID < g_MaxRightsValue || (el.parent().hasClass("full") && g_MaxRightsValue != 0 && isOldUser)) return;  // g_MaxRightsValue - максимальное значение прав, которое может назначить текущий пользователь
  if (rightsID > 0 && !GetFullRightsUserCount(UserID) && isExistUsersWithFullRights()) return ShowInfo(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"));
  if (el.parent().hasClass(rights)) return;

  // Заменяем у выбранного пользователя права.
  var SelUsers = $("input[name='__SELECTED_USERS']");
  var oldSelUsers = SelUsers.val().split(';');
  for (var i = 0; i < oldSelUsers.length; i++) {
    var oldUser = oldSelUsers[i].split('-');
    if (oldUser[0] == UserID) {
      currentRightVal = oldUser[1];
      oldSelUsers[i] = UserID + '-' + rightsID;
      break;
    }
  }
  var rightValue = RightsToNumber($.trim(el.parent().attr("class"))); // до своего уровня.
  // если у нас нет полных прав и мы пытаемся понизить права пользователя которому они уже назначены
  if (g_MaxRightsValue != 0 && rightsID > rightValue && isOldUser && !g_OldChangedUsers[UserID]) return;
  // если мы повышали старому пользователю права (до Изменение при передаче прав) и меняем теперь обратно
  if (isOldUser && rightsID != rightValue) { g_OldChangedUsers[UserID] ? delete g_OldChangedUsers[UserID] : g_OldChangedUsers[UserID] = 1; }

  el.parent().attr("class", rights).removeClass('disabled'); // окрашиваются кружочки
  el.siblings("span").text(L("RIGHT_" + $.trim(el.parent().attr('class').toUpperCase())));
  SelUsers.val(oldSelUsers.join(';'));

  $('.Rights').trigger('rightsChange');
}

// определяет были ли пользователю уже назначены права.
//чтобы при передаче прав юзер не мог менять права тем, кому уже назначены
function IsOldUser(UserID) {
  var SelUsers = $("input[name='__CURRENT_USERS_RIGHTS']");
  var oldSelUsers = SelUsers.val().split(';');
  for (var i = 0; i < oldSelUsers.length; i++) {
    var oldUser = oldSelUsers[i].split('-');
    if (oldUser[0] == UserID) {
      return true;
    }
  }
  return false;
}

function RightsToNumber(right) {
  switch (right) {
    case "full": return 0;
    case "change": return 1;
    case "view": return 2;
  }
}

function IsRightsListValid() {
  var SelUsers = $("input[name='__SELECTED_USERS']");
  if (SelUsers.length > 0) {
    return GetFullRightsUserCount() > 0;
  } else {
    return true;
  }
}

//Получает к-во пользователей с полными правами, с учетом изменений.
function GetFullRightsUserCount(UserID) {
  var SelUsers = $("input[name='__SELECTED_USERS']");
  var oldSelUsers = SelUsers.val().split(';');
  var fullRightsUserCount = 0;
  //Подсчитаем количество пользователей, которые имеют полные права,
  for (var i = 0; i < oldSelUsers.length; i++) {
    var oldUser = oldSelUsers[i].split('-');
    if (oldUser[1] === "0" && oldUser[0] !== UserID)++fullRightsUserCount;
  }
  return fullRightsUserCount;
}

/**
* Проверяет есть ли в списке пользователи с полными правами.
* @function isExistUsersWithFullRights
*/
function isExistUsersWithFullRights() {
  const jselectedUsers = $("input[name='__SELECTED_USERS']");
  const selectedUsersArray = jselectedUsers.val().split(';');

  //Подсчитаем количество пользователей, которые имеют пустой тип прав
  for (let i = 0; i < selectedUsersArray.length; i++) {
    const rightsEntry = selectedUsersArray[i].split('-');
    if (rightsEntry[1] === "0") {
      return true;
    }
  }
  return false;
}

// Циклично изменяет права для пользователя.
function ChangeRightCycle(elem) {
  var sp = $(elem).parent();
  var rightsClass = sp.attr("class");
  var rightsID = sp.children("." + rightsClass).attr("name");
 
  if (!rightsID) rightsID = g_MaxRightsValue;
  if (rightsID == 0 && g_MaxRightsValue > 0) return;
  rightsID -= 1;
  if (rightsID < g_MaxRightsValue) rightsID = 2;

 // Если права изначально не определены, то переводим в View.
  if (rightsClass === 'empty') {
    rightsID = 2;
  }

  sp.children("[name='" + rightsID + "']").click();
}

// Функция при наведении мышки на строку прав.
function UserRightsMouseOver(event) {
  var el = $(event.currentTarget);
  var DelIco = el.find('td:first p');
  if (DelIco.length > 0) {
    el.addClass('over');
    DelIco.css('visibility', 'visible');
  }
}

// Функция при отведение мышки со строки прав.
function UserRightsMouseOut(event) {
  var el = $(event.currentTarget);
  var DelIco = el.find('td:first p');
  if (DelIco.length > 0) {
    DelIco.css('visibility', 'hidden');
    el.removeClass('over');
  }
}

// Удаляет текущего пользователя из прав.
function RemoveUserFromRights(elem) {
  var el = $(elem);
  var tr = el.parent().parent();

  //если пользователь всего один, то удалять его нельзя
  if (tr.parent().parent().find('tbody>tr.rights-table__row').length < 2) {
    ShowInfo(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"));
  } else {
    var UserID = GetUserID(tr);
    // если права не полные, то запретим удалять из списка пользователей которым уже были назначены права
    if (g_MaxRightsValue != 0 && IsOldUser(UserID)) return;
    var SelUsers = $("input[name='__SELECTED_USERS']");
    var oldSelUsers = SelUsers.val().split(';');


    //Если пользователь с полными правами один и мы его удаляем,
    if (!GetFullRightsUserCount(UserID) && isExistUsersWithFullRights()) return ShowInfo(L("WARN_EMPRY_RIGHTS_ISNOT_VALID"));
    // Удяляет выбранного пользователя из права.
    for (var i = 0; i < oldSelUsers.length; i++) {
      var oldUser = oldSelUsers[i].split('-');
      if (oldUser[0] == UserID) {
        oldSelUsers[i] = '';
        break;
      }
    }

    SelUsers.val(oldSelUsers.join(';').replace(';;', ';'));
    tr.remove();

    MarkUser($('.Rights').find('div#' + UserID), false);
  }


  $('.Rights').trigger('rightsChange');
}

function MarkUser(el, mark) {
  if (el.length > 0) {
    if (el.hasClass('bubble')) {
      // Если выбран показываем галочку.
      if (mark) {
        el.unbind('mouseenter mouseleave').children('i').attr('title', '');
      } else {
        // Если нет, то при наведении показываем стрелочку для добавления пользователя в права.
        el
        .hover(function () {
          $(this).children('i').show();
        }, function () {
          $(this).children('i').hide();
        })
        .children('i')
        .removeClass('TaskAndJob/PerformJob_16.png').addClass('Rights_AddUserOrGroup.png')
        .attr('title', L('ADD'))
        .hide()
        .one('click.Rights', function () { //событие click уберется после первого клика по стрелочке
          AddUserByDiv(el.data('div'));
          MarkUser(el, true);
        });
      }
    } else {
      el = $('.Rights').find('div#' + el.attr('id')); // находим все такие элементы в дереве
      if (el.length > 0) {
        var img = el.find('p.icon');
        if (el.attr('id').charAt(0) != 'g') // user
        {
          if (mark) {
            img.removeClass('user-tree__icon_user').removeClass('user-tree__icon_fav-user').addClass('user-tree__icon_selected-user');
            el.addClass('marked');
          } else {
            img.removeClass('user-tree__icon_selected-user').addClass(el.hasClass('favorite') ? 'user-tree__icon_fav-user' : 'user-tree__icon_user');
            $('.treeview > #0').find('.user-tree__icon_fav-user').removeClass('user-tree__icon_fav-user').addClass('user-tree__icon_user');
            el.removeClass('marked');
          }
        } else { // group
          if (mark) {
            img.removeClass('user-tree__icon_group').removeClass('user-tree__icon_fav-group').addClass('user-tree__icon_selected-group');
            el.addClass('marked');
          } else {
            img.removeClass('user-tree__icon_selected-group').addClass(el.hasClass('favorite') ? 'user-tree__icon_fav-group' : 'user-tree__icon_group');
            $('.treeview > #0').children('ul').find('.user-tree__icon_fav-group').removeClass('user-tree__icon_fav-group').addClass('user-tree__icon_group');
            el.removeClass('marked');
          }
        }
      }
    }
  }
}

// Добавляет пользователя.
function AddUserByDiv(elem) {
  var el = $(elem);
  var NewUserID = el.attr('id');
  var NewUserName = el.find('span > div').text();

  var table = $('.Rights_Table');
  var lastFilledRow = table.find('tr:last');

  if (table.find(`tr#new_${NewUserID},tr#current_${NewUserID}`).length) {
    // не добавляем юзеров несколько раз
    return false;
  }

  $('.Rights').trigger('rightsChange');

  MarkUser(el, true);

  // Для добавляемых пользователей по умолчанию права только на чтение.
  const NewUserRight = 2;

  let newRow = lastFilledRow.clone(true);
  newRow.attr('id', 'new_' + NewUserID);

  // на случай если включено делегирование прав
  let jRemoveButton = newRow.find('svg:first');
  jRemoveButton.attr('title', L('REMOVE_FROM_RIGHTS_LIST'));
  try {
    jRemoveButton[0].classList.remove('disabled');
  } catch(e) {}

  let jCircleCell = newRow.find('td:last');
  jCircleCell.attr('title', L('PUSH_TO_CHANGE_TYPE_RIGHT'));

  // При копировании последней заполненной, копируются и стили disabled.
  // Снимем их в соответствии с максимально возможными для назначения правами.
  $.each(jCircleCell.find('svg'), (index, element) => {
    let jCellElement = $(element);
    let circleRight = +jCellElement.attr('name');
    if (circleRight >= g_MaxRightsValue) {
      jCellElement.removeClass('disabled');
      jCellElement.attr('title', '');
    } else {
      jCellElement.addClass('disabled');
      jCellElement.attr('title', L('CANNOT_ASSIGN_RIGHTS_HIGHER'));
    }
  });
  jCircleCell.find('span').removeClass('disabled');

  var newRow_div = newRow.find('td div').text(NewUserName);
  lastFilledRow.after(newRow.show());

  //Подсказка
  var hintData = getHintDataObj(el);
  if (typeof hintData !== 'undefined') {
    // Подсказка есть, значит НЕ надо показать обычный title.
    newRow_div.removeAttr('title');

    var hint = newRow.find('.Rights_Table_td');
    hint.removeClass('hintInit').qtip('hide').removeAttr('data-hint').data('data-hint', hintData)
    InitAdditionalInfoTooltip(hint);
  } else {
    // Подсказки нет, значит надо показать обычный title.
    newRow_div.attr('title', NewUserName);
    var rightsCell = newRow.find('.Rights_Table_td');
    rightsCell.removeClass('hint').removeClass('hintInit').qtip('hide').qtip('destroy');
    rightsCell.removeAttr("data-hint");
  }

  // Переинициализируем подсказки.
  newRow.parent().find('.hint').each(function () {
    $(this).removeClass('hintInit').qtip('hide');
    InitAdditionalInfoTooltip($(this));
  });

  SetNewRight(newRow.find('td:last svg:first'), NewUserRight);

  var SelUsers = $("input[name='__SELECTED_USERS']");
  var oldSelUsers = SelUsers.val();
  SelUsers.val(oldSelUsers + NewUserID + '-' + NewUserRight + ';');

  return true;
}

/* =Фильтрация пользователей в правах================================================================================================================== */
var UserFilterTTimeout;
function ClearInputFilterUser(el) {
  if (!$.ipad) {
    if ($(el).hasClass('Req_Gray')) {
      $(el).removeClass('Req_Gray');
      $(el).val('');
    }
  } else {
    $(el).trigger('keyup');
  }
}
function SetDefaultFilterValue(el, value) {
  if (!$.ipad) {
    if ($(el).val().length == 0) {
      $(el).val(value);
      $(el).addClass('Req_Gray');
    }
  }
}

function FilterUser(idSrc, idDest, el) {
  clearTimeout(UserFilterTTimeout);
  UserFilterTTimeout = setTimeout(function () { DoFilter(idSrc, idDest, el); }, 400);
}
function DoFilter(idSrc, idDest, el) {
  var elJq = $(el);
  var value = $.trim(elJq.val());
  if (value.length != 0) {
    $('#' + idDest).empty();
    var GlobalFilterUser = "";
    $('#' + idSrc + ' span[innerHTML]').each(function () {
      if (($(this).attr('innerHTML').toUpperCase().indexOf(value.toUpperCase()) != -1) && ($(this).parent().attr('id').split('g_').length == 1)) {
        var div = $(this).parent();
        if (GlobalFilterUser.indexOf(div.attr('id')) == -1) {
          var cloneDiv = div.clone(true);
          $('#' + idDest).append(cloneDiv);
          GlobalFilterUser = GlobalFilterUser + div.attr('id') + ";";
        }
      }
    });
    $('#' + idDest).show();
    $('#' + idSrc).hide();
  }
  else {
    $('#' + idDest).empty().hide();
    $('#' + idSrc).show();
  }
}

function FilterUserAjax(ev, UserTreeId, FilterAreaId, ObjectID, ObjectType, el, defvalue) {
  clearInlineHint(el);
  clearTimeout(UserFilterTTimeout);
  UserFilterTTimeout = setTimeout(function () { AjaxUserSearch(UserTreeId, FilterAreaId, ObjectID, ObjectType, el, defvalue); }, 400);
  return ev.keyCode != 13;
}

//Поиск пользователей с помощью ajax.
function AjaxUserSearch(UserTreeId, FilterAreaId, ObjectID, ObjectType, el, defvalue) {
  var elJq = $(el);
  var value = $.trim(elJq.val());
  if (value.length != 0 && value != defvalue) {

    if (Core.isStatisticEnabled) {
      ///Запись в статистику
      WA.CR.statistics.write({
        page: WA.getLocation(),
        action: "FilterQuery",
        area: 'UsersTree',
        target: elJq.get(0)
      });
    };

    $.ajax({
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      url: "/UserList.asmx/GetUsers",
      data: "{'ObjectID':" + ObjectID + ", 'ObjectType':" + ObjectType + ", 'FolderID':'', 'Filtrator':'" + value + "'}",
      async: true,
      cache: false,
      success: function (res) {
        var FilterArea = $('#' + FilterAreaId);
        $('#' + UserTreeId).hide();
        $('#ShowingTreeError').hide();

        var SelUsers = ';' + $("input[name='__SELECTED_USERS']").val();

        FilterArea.empty().show();

        if (res.d.Result.length == 0) {
          FilterArea.append('<div class="rights-empty-with-filter">' + L('EMPTY_WITH_FILTER') + '</div>');
        } else {
          $(res.d.Result).each(function () {
            var currUser = this;
            var itemId = currUser.id;
            if (currUser.isGroup) itemId = 'g_' + itemId;
            var isSelected = (SelUsers.indexOf(';' + itemId + '-') != -1);
            var u;
            if (currUser.id > -1) {
              if (currUser.hint == null) {
                // Подсказки НЕ настроены.
                u = $(currUser.text);
                if (u.hasClass('hint')) {
                  u.each(function () {
                    InitAdditionalInfoTooltip($(this));
                  });
                }
                MarkUser(u, isSelected);
              } else {
                // Подсказки настроены.
                u = $(GenerateAdditionalInfoTooltipHtml(currUser.hint));
                u.attr('id', itemId).data('div', currUser.text).append('<i class="RightsMarkIco">');
                MarkUser(u, isSelected);
              }
            } else {
              // -1 - сообщение об ошибке.
              if (this.text) {
                u = $('<div class="notallshown">' + (currUser.text) + '</div>');
              } else {
                u = null;
              }
            }
            if (u) {
              FilterArea.append(u);
            }
          });
          if ($.ipad || WA.ENV.isAndroid()) {
            InitTabletContextMenu(FilterArea.find('.Rights_List_div'));
          }
          MarkAllGroupsAndUsers($('.Rights'));
        };
      }
    });
  } else {
    $('#' + UserTreeId).show();
    CheckIfFavoritesEmpty($('li#0'));
    var rightsTable = $('.Rights');
    if (rightsTable.data('needUpdTree') == true) {
      rightsTable.trigger('reload.UserTree', [false]);
      rightsTable.data('needUpdTree', null);
    }
    $('#' + FilterAreaId).hide();
  }
}

function InitRightsUserTreeKeyNavigation() {
  var tree = $('ul.treeview:visible');
  var filterResults = $('.Filter_User_View');
  var mainContent = $('#scroller');
  var rightsTable = $('.Rights_Table');
  var rightsUserList = $('.Rights_User_List');
  if (!$.ipad) {
    mainContent.height(mainContent.parent().parent().height()).css('overflow', 'auto');
  }

  var UpDownKeyNavigation = function (down) {
    if (tree.length > 0 && tree.css('display') != "none") {
      var currentItem = tree.find('div.over').parents('li:first');
      if (currentItem.length) {
        // от текущего элемента делаем поиск в 3-х направлениях: в дочерних элементах, в следующих элементах на уровень выше и в элементах того же уровня
        var nextItem;
        if (down) {
          nextItem = currentItem.find('li:visible:first');
          if (nextItem.length == 0) { // если не нашли внизу
            nextItem = FindSiblingOrParent(currentItem, down);
          }
        }
        else {
          nextItem = FindSiblingOrParent(currentItem, down);
        }
        if (nextItem.length) {
          UnhoverAllItems();
          HoverItem(nextItem);
          ScrollToHoveredItem(nextItem, down);
        }
      }
      else {
        if (down) {
          HoverItem(tree.find('li:visible:first'));
          mainContent.scrollTop(0);
        }
        else {
          HoverItem(tree.find('li:visible:last'));
          mainContent.scrollTop(100000);
        }
      }
    }
    else {
      var currentItem = filterResults.find('div.over');
      if (currentItem.length) {
        var nextItem;
        if (down) {
          nextItem = currentItem.next('.Rights_List_div');
        }
        else {
          nextItem = currentItem.prev();
        }
        if (!nextItem.length) nextItem = currentItem;
        UnhoverAllItems();
        HoverItem(nextItem);
        ScrollToHoveredItem(nextItem, down);
      }
      else {
        if (down) {
          HoverItem(filterResults.children('div:first:visible'));
          mainContent.scrollTop(0);
        }
        else {
          HoverItem(filterResults.children('div:last:visible'));
          mainContent.scrollTop(100000);
        }
      }
    }
  };

  var FindSiblingOrParent = function (item, down) {
    var nextItem;
    if (down) {
      nextItem = item.next('li:visible:first'); // ищем след элемент на этом же уровне
      if (nextItem.length == 0) { // если не нашли
        if (!item.parent('.treeview').length) { // и если родительский элемент это не все дерево, и значит есть куда подниматься выше
          nextItem = FindSiblingOrParent(item.parents('li:visible:first'), down); // ищем сиблингов у родителя или его родителей
        } else {
          nextItem = item;
        }
      }
    } else { // движение вверх
      nextItem = item.prev('li:visible:first'); // ищем сперва сиблинга
      var sibling = true;
      if (nextItem.length == 0) { // если его не нашли и родительский элемент не само дерево, и значит есть куда подниматься выше
        if (!item.parent('.treeview').length) {
          nextItem = item.parents('li:visible:first'); // то берем родителя
          sibling = false;
          if (nextItem.length == 0) { // если его не нашли, то пытаемся найти сиблинга родителя или его родителей
            nextItem = FindSiblingOrParent(item.parents('li:visible:first'), down);
          }
        } else { // если родитель - это все дерево, то мы на крайнем элементе и никуда не двигаемся
          nextItem = item;
          sibling = false;
        }
      }
      if (sibling) { // если нашли сиблинга, то проверяем наличие дочерних узлов и переходим к ним
        var subItem = nextItem.find('li:visible:last');
        if (subItem.length) {
          nextItem = subItem;
        }
      }
    }
    return nextItem;
  };

  var ExpandOrCollapseGroup = function (expand) {
    if (tree.length > 0 && tree.css('display') != "none") {
      var currentItem = tree.find('div.over').parents('li:visible:first');
      if (expand) {
        if (currentItem.hasClass('expandable')) {
          currentItem.children('div.hitarea').click();
        }
      } else {
        if (currentItem.hasClass('collapsable')) {
          currentItem.children('div.hitarea').click();
        } else {
          if (!currentItem.parent('.treeview').length) {
            var parent = currentItem.parents('li:visible:first');
            UnhoverAllItems();
            HoverItem(parent);
            parent.children('div.hitarea').click();
          }
        }
      }
    }
  };

  var ScrollToHoveredItem = function (item, down) {
    if (tree.filter(':visible').height() > mainContent.height() ||
      (filterResults.height() > mainContent.height() && filterResults.css('display') != "none")) {

      var height = 65;
      var currentID = item.attr('id');
      var lis = tree.filter(':visible').length ? tree.find('li:visible') : filterResults.children('.Rights_List_div');


      if (down) {
        for (var i = lis.length - 1; i >= 0; i--) {
          if ($(lis[i]).attr('id') == currentID) {
            height += (i + 1) * 24;
            break;
          }
        }
        if (mainContent.height() - height < 100) {
          mainContent.scrollTop(mainContent.scrollTop() + 24);
        }
      } else {
        for (var i = 0; i < lis.length; i++) {
          if ($(lis[i]).attr('id') == currentID) {
            height += (i + 1) * 24;
            break;
          }
        }
        if (height - mainContent.scrollTop() < 100) {
          mainContent.scrollTop(mainContent.scrollTop() - 24);
        }
      }
    }
  };

  var HoverItem = function (item) {
    UnhoverAllItems();
    if (tree.length == 0 || tree.css('display') == "none") {
      item.filter('div.Rights_List_div:first').addClass('over');
    } else {
      item.find('div.Rights_List_div:first').addClass('over');
    }
    if (!item.hasClass('notallshown') && item.length) {
      if (item.find('p:first')[0].className.indexOf('Marked') == -1) {
        item.find('p.treeview_img_action:first').css('visibility', 'visible');
      }
    }
  };
  var UnhoverAllItems = function () {
    var title = rightsUserList.find('div.over'); //tree.css('display') == "none" ? filterResults.find('div.over') : tree.find('div.over');
    if (title.length == 0) title = rightsUserList.find('ul').find('div.over');
    title.removeClass('over').find('p.treeview_img_action').css('visibility', 'hidden');
    title.parent().removeClass('hover');
  };

  var SelectItem = function () {
    tree.length == 0 || tree.css('display') == "none" ?
      filterResults.find('div.over').click() :
      tree.find('div.over').click();
  };

  var DeselectItem = function () {
    var item = tree.length == 0 || tree.css('display') == "none" ?
      filterResults.find('div.over').click() :
      tree.find('div.over').click();
    var tr = rightsTable.find('tr[id$="_' + item.attr('id') + '"]');
    RemoveUserFromRights(tr.find('td:first').children());
  };

  var scope = 'common';
  key('down', scope, function () { UpDownKeyNavigation(true); return false; });
  key('up', scope, function () { UpDownKeyNavigation(false); return false; });
  key('right', scope, function () { ExpandOrCollapseGroup(true); return false; });
  key('left', scope, function () { ExpandOrCollapseGroup(false); return false; });
  key('enter', scope, function () { SelectItem(); return false; });
  key('delete', scope, function () { DeselectItem(); return false; });
  key('shift+tab', scope, function () { $(':focus').blur(); $('input.Filter_Text').focus(); UnhoverAllItems(); return false; });
  $('input.Filter_Text').focus(function () { ClearInputFilterUser(this); UnhoverAllItems(); });
  //  key('shift+down', function () { UpDownKeyNavigation(true); return false; });
  //  key('shift+up', function () { UpDownKeyNavigation(false); return false; });
  //  key('shift+right', function () { ExpandOrCollapseGroup(true); return false; });
  //  key('shift+left', function () { ExpandOrCollapseGroup(false); return false; });
  //  key('shift+enter', function () { SelectItem(); return false; });
  //  key('shift+delete', function () { DeselectItem(); return false; });
}
